import { Button, Flex, Text } from '@chakra-ui/react';
import { X, Warning } from '@phosphor-icons/react';
import useAuth from '@/store/auth';
import { useNavigate } from 'react-router-dom';

export default function AdminSessionBanner() {
  const { account, logout } = useAuth();
  const navigate = useNavigate();

  // Only show banner if logged in as user and login_by_admin is true
  if (!account || !account.login_by_admin) {
    return null;
  }

  const handleCloseSession = () => {
    navigate('/admin/users', { replace: true });
    setTimeout(() => {
      logout();
    }, 100);
  };

  return (
    <Flex
      w="100%"
      bg="orange.500"
      color="white"
      py="12px"
      px="20px"
      alignItems="center"
      justifyContent="center"
      position="relative"
      zIndex={100}
      boxShadow="0 2px 4px rgba(0,0,0,0.1)"
    >
      <Flex alignItems="center" gap="8px">
        <Warning size={20} weight="fill" />
        <Text fontSize="14px" fontWeight="600">
          Admin Mode: You are viewing this account as {account.name} ({account.email})
        </Text>
      </Flex>
      <Button
        ml="auto"
        size="sm"
        bg="white"
        color="orange.500"
        _hover={{ bg: 'orange.50' }}
        onClick={handleCloseSession}
        borderRadius="6px"
        fontSize="14px"
        fontWeight="600"
        h="32px"
        px="16px"
        display="flex"
        gap="6px"
        alignItems="center"
      >
        <X size={16} weight="bold" />
        Close Session
      </Button>
    </Flex>
  );
}
